import Component from './Companies';

export default Component;
